import React from "react";
import Zoom from "react-medium-image-zoom";

export const SMARTSPlusImg = (props) => {
  let path = `/img/`;
  let id = props.id;

  if (id.includes("CC")) {
    path += `rxns/${id}.png`;
  } else {
    path += `synthons/SYN-${id}.png`;
  }

  return (
    <Zoom>
      <img
        className="rounded-4"
        width={"100%"}
        src={path}
        alt={`${id}.png`}
      ></img>
    </Zoom>
  );
};
